<template>
    <div class="col-md-12">
        <div class="card">
            <div class="card-header pb-0">
                <h4><b>Póliza:</b> {{ this.store.polizaNumero }}</h4>
                <h6><b>Id póliza:</b> {{ this.store.polizaId }}</h6>
                <h6><b>Id versión:</b> {{ this.store.polizaVersionId }}</h6>
                <h6><b>Id contratante:</b> {{ this.store.contratanteId }}</h6>
                <button class="btn btn-danger float-end" @click="store.resetForm">
                    <vue-feather type="refresh-cw" size="16"></vue-feather> Reiniciar
                </button>
                <span><b>Instrucciones:</b> 
                    <br />1. Complete todos los campos requeridos.
                    <br />2. Navegue a través de las secciones del formulario.
                    <br />3. Revise la información antes de enviarla a la aseguradora.
                </span>
                <br />
            </div>
            <div class="card-body">
                <Wizard 
                    ref="wizardRef"
                    :custom-tabs="[
                        {
                            title: 'Contratante',
                        },
                        {
                            title: 'Laborales',
                        },
                        {
                            title: 'Producto',
                        },
                        {
                            title: 'Asegurados',
                        },
                        {
                            title: 'Cotización',
                        },
                        {
                            title: 'Orden de trabajo',
                        },
                    ]" 
                    :beforeChange="onTabBeforeChange" 
                    @change="onChangeCurrentTab" 
                    @complete:wizard="wizardCompleted"                    
                >
                <!-- Le quité la acción de submit arriba en el wizard -->
                
                <!-- Tabs -->
                <div class="col-xs-12" v-if="currentTabIndex === 0">
                    <contratante ref="contratanteForm" @nextTab="onChildNextTab" />
                </div>                    
                <div class="col-xs-12 text-start" v-if="currentTabIndex === 1">
                         <laborales @nextTab="onChildNextTab" />
                </div>
                <div class="col-xs-12 text-start" v-if="currentTabIndex === 2">
                    <productos @nextTab="onChildNextTab" />                    
                </div>
                <div class="col-xs-12 text-start" v-if="currentTabIndex === 3">
                    <asegurados @nextTab="onChildNextTab" />                    
                </div>
                <div class="col-xs-12 text-start" v-if="currentTabIndex === 4">
                    <cotizacion @nextTab="onChildNextTab" />
                </div>
                <div class="col-xs-12 text-start" v-if="currentTabIndex === 5">
                    <ordenTrabajo />
                </div>
                <!-- End Tabs -->
                </Wizard>
            </div>
        </div>
    </div>
</template>

<script>
import "form-wizard-vue3/dist/form-wizard-vue3.css";
import Wizard from "form-wizard-vue3";
import contratante from "./formularioContratante.vue";
import laborales from "./formularioLaborales.vue";
import productos from "./formularioProductos.vue";
import asegurados from "./formularioAsegurados.vue";
import cotizacion from "./formularioCotizacion.vue";
import ordenTrabajo from "./ordenTrabajo.vue";

import { useSeguroStore } from '@/stores/seguroStore';
import api from '@/axios';
import getField from '@/utils/getField';

export default {
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    name: "App",
    components: {
        Wizard,
        contratante,
        laborales,
        productos,
        asegurados,
        cotizacion,
        ordenTrabajo
    },
    data() {
        return {
            currentTabIndex: 0,
        };
    },
    methods: {
        onChildNextTab() {
            if (this.$refs.wizardRef && typeof this.$refs.wizardRef.nextTab === 'function') {
                this.$refs.wizardRef.nextTab();
                return;
            }
            this.currentTabIndex = this.currentTabIndex + 1;
        },
        onChangeCurrentTab(index, oldIndex) {
            this.currentTabIndex = index;
        },
        onTabBeforeChange() {
            return true;
        },
        async wizardCompleted() {
            let polizaVersionId = this.store.polizaVersionId;

            // Red de seguridad: si ningún paso del wizard logró capturar el
            // polizaVersionId de su respuesta, se recupera directo del detalle.
            if (!polizaVersionId && this.store.polizaId) {
                try {
                    const detalle = await api.get(`wizard/poliza/${this.store.polizaId}`);
                    polizaVersionId = getField(detalle.data || {}, 'polizaVersionId');
                    this.store.polizaVersionId = polizaVersionId || '';
                } catch {
                    // se maneja abajo con el mensaje de "no se encontró"
                }
            }

            if (!polizaVersionId) {
                alert('No se encontró el id de la versión de la póliza.');
                return;
            }
            try {
                await api.post(`parcialidades/generar/${polizaVersionId}`);
            } catch {
                alert('No se pudieron generar las parcialidades de la póliza.');
            } finally {
                this.$router.push({ name: 'emitidasPolizas' });
            }
        },
    },
};
</script>

<style>
.form-wizard-vue .fw-step-active {
    background: #66964a !important;
}
.form-wizard-vue .fw-step-checked {
    border: 2px solid #66964a !important;
}
.form-wizard-vue .fw-body-list .fw-list-progress-active {
    background: #66964a !important;
}
.fw-btn:not(.fw-btn-back) {
    background: #66964a !important;
}
</style>